import axios, { AxiosResponse } from "axios";
import { ROOT_URL, DEV_MODE } from "./env";
import { GrantViewTypes, ImpactViewTypes, PIViewTypes, QueryViewTypes, InteractionTypes, MainViewTypes, UserManagementTypes } from "../types/data";


import { ROOT_URL as API, PROGRESS_ROOT_URL } from "./env";
// const API = ROOT_URL;

import { openProgressStream } from './sseManager';


// 1. utils
// uuid for progress manager (streaming output in mainview API)
export function uuid() {
  return ([1e7] as any+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, (c:any) =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> (c as any) / 4).toString(16)
  );
}

// check response
function checkResponse<T>(response: AxiosResponse<T>, fallback: T): T {
  if (response.status === 200) return response.data;
  console.error(`Data fetching error: ${response.status}`);
  if (DEV_MODE) {
    console.error(response);
    throw response;
  }
  return fallback;
}

// 2. all api functions
// ===== test (begin) =====
export async function getBackendDataAPI(params: number): Promise<string> {
  const url = `${API}/test`
  const response = await axios.post(url, params)
  const data: string = checkResponse(response, [])
  return data
}
export async function loadMsgAPI(): Promise<string> {
  const url = `${API}/members`;
  const response = await axios.get(url);
  const data: string = checkResponse(response, []);
  return data
}
export async function getNameAPI(params: { index : number }): Promise<string> {
  const url = `${API}/get_name`;
  const response = await axios.post(url, params);
  const data: string = checkResponse(response, []);
  // console.log('async func: ', data)
  // const dataset = d3.csvParseRows(data);
  // return dataset;
  return data
}
export async function getData(params: { dataId: string }): Promise<string[][]> {
  const url = `${API}/data`;
  const response = await axios.get(url, { params });
  const data = checkResponse(response, []);
  // const dataset = d3.csvParseRows(data);
  // return dataset;
  return data
}
// ===== test (end) =====


// =============================
// ===== side view (begin) =====
// =============================

// --- Query View (begin) ---
export async function getGrantIdListAPI(params: QueryViewTypes.QueryViewAPIParams): Promise<string[]> {
  const url = `${API}/get_grant_id_list`;
  const param = {
    start_year: params.startYear,
    end_year: params.endYear,
    funding_usd: params.fundingUSD,
    country: params.country,
    funding_agency: params.fundingAgency,
    sub_institute: params.subInstitute,
    keyword: params.keyword,
  }
  const response = await axios.post(url, param);
  const data: string[] = checkResponse(response, []);
  // console.log('getGrantIdListAPI, data: ', data);
  return data
}
export async function getGrantIdListUsingGrantFieldAPI(grantFieldCodeList: number[], grantIDList: string[]): Promise<string[]> {
  const url = `${API}/get_grant_id_list_using_grant_field`;
  const param = {
    grant_topic_code_list: grantFieldCodeList,
    grant_id_list: grantIDList,
  }
  const response = await axios.post(url, param);
  const data: string[] = checkResponse(response, []);
  return data
}
// --- Query View (end) ---


// --- Grant View (begin) ---
export async function getGrantViewDataAPI(params: string[]): Promise<GrantViewTypes.GrantViewPayload> {
  const url = `${API}/get_grant_view_data`;
  const param = {
    grant_id_list: params,
  }
  const response = await axios.post(url, param);
  const data: GrantViewTypes.GrantViewPayload = checkResponse(response, []);
  return data
}
// --- Grant View (end) ---


// --- PI View (begin) ---
export async function getPIViewDataAPI(params: string[]): Promise<PIViewTypes.PIViewPayload> {
  const url = `${API}/get_pi_view_data`;
  const param = {
    grant_id_list: params,
  }
  const response = await axios.post(url, param);
  const data: PIViewTypes.PIViewPayload = checkResponse(response, []);
  return data
}
export async function getPIViewCardListDataAPI(grant_id_list: string[], selected_university: string, selected_sort_metric: string): Promise<PIViewTypes.PIStatisticsUnit[]> {
  const url = `${API}/get_pi_view_card_list_data`;
  // console.log('getPIViewCardListDataAPI(), params: ', params)
  const param = {
    grant_id_list: grant_id_list,
    selected_university: selected_university,
    selected_sort_metric: selected_sort_metric,
  }

  const response = await axios.post(url, param);
  const data: PIViewTypes.PIStatisticsUnit[] = checkResponse(response, []);
  return data
}
export async function getPIViewPredictedCardListDataAPI(predicted_grant_id_list: string[], global_predicted_grant_id_list: string[], selected_university: string, selected_sort_metric: string): Promise<PIViewTypes.PIStatisticsUnit[]> {
  const url = `${API}/get_pi_view_predicted_card_list_data`;
  const param = {
    predicted_grant_id_list: predicted_grant_id_list,
    global_predicted_grant_id_list: global_predicted_grant_id_list,
    selected_university: selected_university,
    selected_sort_metric: selected_sort_metric,
  }

  // console.log('==> getPIViewPredictedCardListDataAPI(), param: ', param)
  const response = await axios.post(url, param);
  const data: PIViewTypes.PIStatisticsUnit[] = checkResponse(response, []);
  return data
}
// --- PI View (end) ---


// --- Impact Type View [upper-right corner view] (begin) ---
export async function getImpactStatisticsViewDataAPI(params: string[]): Promise<ImpactViewTypes.ImpactStatisticsViewPayload> {
  const url = `${API}/get_impact_statistics_view_data`;
  const param = {
    grant_id_list: params,
  }
  const response = await axios.post(url, param);
  const data: ImpactViewTypes.ImpactStatisticsViewPayload = checkResponse(response, []);
  return data
}
// --- Impact Type View [upper-right corner view] (end) ---


// --- Impact Entity View [lower-right corner view] (begin) ---
export async function getImpactEntityViewDirectPaperDataAPI(grant_id_list: string[], entity_topic: string, entity_level: string, grant_field_id: string): Promise<ImpactViewTypes.ImapctEntityViewPayload>  {
  const url = `${API}/get_impact_entity_view_direct_paper_data`;
  const param = {
    grant_id_list: grant_id_list,
    entity_topic: entity_topic,
    entity_level: entity_level,
    grant_field_id: grant_field_id,
  }
  const response = await axios.post(url, param);
  const data: ImpactViewTypes.ImapctEntityViewPayload = checkResponse(response, []);
  return data
}
export async function getImpactEntityViewDirectPatentDataAPI(grant_id_list: string[], entity_topic: string, entity_level: string, grant_field_id: string): Promise<ImpactViewTypes.ImapctEntityViewPayload>  {
  const url = `${API}/get_impact_entity_view_direct_patent_data`;
  const param = {
    grant_id_list: grant_id_list,
    entity_topic: entity_topic,
    entity_level: entity_level,
    grant_field_id: grant_field_id,
  }
  const response = await axios.post(url, param);
  const data: ImpactViewTypes.ImapctEntityViewPayload = checkResponse(response, []);
  return data
}
export async function getImpactEntityViewDirectClinicalTrialDataAPI(grant_id_list: string[], entity_topic: string, entity_level: string, grant_field_id: string): Promise<ImpactViewTypes.ImapctEntityViewPayload>  {
  const url = `${API}/get_impact_entity_view_direct_clinical_trial_data`;
  const param = {
    grant_id_list: grant_id_list,
    entity_topic: entity_topic,
    entity_level: entity_level,
    grant_field_id: grant_field_id,
  }
  const response = await axios.post(url, param);
  const data: ImpactViewTypes.ImapctEntityViewPayload = checkResponse(response, []);
  return data
}
export async function getImpactEntityViewDirectClinicalTrialTypeDataAPI(grant_id_list: string[], entity_topic: string, entity_level: string, grant_field_id: string): Promise<ImpactViewTypes.ImapctEntityViewPayload>  {
  const url = `${API}/get_impact_entity_view_direct_clinical_trial_type_data`;
  const param = {
    grant_id_list: grant_id_list,
    entity_topic: entity_topic,
    entity_level: entity_level,
    grant_field_id: grant_field_id,
  }
  const response = await axios.post(url, param);
  const data: ImpactViewTypes.ImapctEntityViewPayload = checkResponse(response, []);
  return data
}
export async function getImpactEntityViewIndirectPatentDataAPI(grant_id_list: string[], entity_topic: string, entity_level: string, grant_field_id: string): Promise<ImpactViewTypes.ImapctEntityViewPayload>  {
  const url = `${API}/get_impact_entity_view_indirect_patent_data`;
  const param = {
    grant_id_list: grant_id_list,
    entity_topic: entity_topic,
    entity_level: entity_level,
    grant_field_id: grant_field_id,
  }
  const response = await axios.post(url, param);
  const data: ImpactViewTypes.ImapctEntityViewPayload = checkResponse(response, []);
  return data
}
export async function getImpactEntityViewIndirectClinicalTrialDataAPI(grant_id_list: string[], entity_topic: string, entity_level: string, grant_field_id: string): Promise<ImpactViewTypes.ImapctEntityViewPayload>  {
  const url = `${API}/get_impact_entity_view_indirect_clinical_trial_data`;
  const param = {
    grant_id_list: grant_id_list,
    entity_topic: entity_topic,
    entity_level: entity_level,
    grant_field_id: grant_field_id,
  }
  const response = await axios.post(url, param);
  const data: ImpactViewTypes.ImapctEntityViewPayload = checkResponse(response, []);
  return data
}
export async function getImpactEntityViewIndirectClinicalTrialTypeDataAPI(grant_id_list: string[], entity_topic: string, entity_level: string, grant_field_id: string): Promise<ImpactViewTypes.ImapctEntityViewPayload>  {
  const url = `${API}/get_impact_entity_view_indirect_clinical_trial_type_data`;
  const param = {
    grant_id_list: grant_id_list,
    entity_topic: entity_topic,
    entity_level: entity_level,
    grant_field_id: grant_field_id,
  }
  const response = await axios.post(url, param);
  const data: ImpactViewTypes.ImapctEntityViewPayload = checkResponse(response, []);
  return data
}
export async function getImpactEntityViewIndirectPolicyDataAPI(grant_id_list: string[], entity_topic: string, entity_level: string, grant_field_id: string): Promise<ImpactViewTypes.ImapctEntityViewPayload>  {
  const url = `${API}/get_impact_entity_view_indirect_policy_data`;
  const param = {
    grant_id_list: grant_id_list,
    entity_topic: entity_topic,
    entity_level: entity_level,
    grant_field_id: grant_field_id,
  }
  const response = await axios.post(url, param);
  const data: ImpactViewTypes.ImapctEntityViewPayload = checkResponse(response, []);
  return data
}
export async function getImpactEntityViewIndirectPolicySourceCountryDataAPI(grant_id_list: string[], entity_topic: string, entity_level: string, grant_field_id: string): Promise<ImpactViewTypes.ImapctEntityViewPayload>  {
  const url = `${API}/get_impact_entity_view_indirect_policy_source_country_data`;
  const param = {
    grant_id_list: grant_id_list,
    entity_topic: entity_topic,
    entity_level: entity_level,
    grant_field_id: grant_field_id,
  }
  const response = await axios.post(url, param);
  const data: ImpactViewTypes.ImapctEntityViewPayload = checkResponse(response, []);
  return data
}
export async function getImpactEntityViewIndirectPolicySourceTitleDataAPI(grant_id_list: string[], entity_topic: string, entity_level: string, grant_field_id: string): Promise<ImpactViewTypes.ImapctEntityViewPayload>  {
  const url = `${API}/get_impact_entity_view_indirect_policy_source_title_data`;
  const param = {
    grant_id_list: grant_id_list,
    entity_topic: entity_topic,
    entity_level: entity_level,
    grant_field_id: grant_field_id,
  }
  const response = await axios.post(url, param);
  const data: ImpactViewTypes.ImapctEntityViewPayload = checkResponse(response, []);
  return data
}
export async function getImpactEntityViewIndirectNewsfeedDataAPI(grant_id_list: string[], entity_topic: string, entity_level: string, grant_field_id: string): Promise<ImpactViewTypes.ImapctEntityViewPayload>  {
  const url = `${API}/get_impact_entity_view_indirect_newsfeed_data`;
  const param = {
    grant_id_list: grant_id_list,
    entity_topic: entity_topic,
    entity_level: entity_level,
    grant_field_id: grant_field_id,
  }
  const response = await axios.post(url, param);
  const data: ImpactViewTypes.ImapctEntityViewPayload = checkResponse(response, []);
  return data
}
// --- Impact Entity View [lower-right corner view] (end) ---









// =============================
// ====== side view (end) ======
// =============================







// TODO: clean the code below (@yifang)
// Search
export async function searchImpactEntityViewPaperDataAPI(grant_id_list: string[], search_keyword: string, entity_level: string): Promise<ImpactViewTypes.ImapctEntitySearchPayload>  {
  const url = `${API}/search_impact_entity_view_paper_data`;
  const param = {
    grant_id_list: grant_id_list,
    search_keyword: search_keyword,
    entity_level: entity_level,
  }
  // console.log('searchImpactEntityViewPaperDataAPI(), param: ', param)

  const response = await axios.post(url, param);
  const data: ImpactViewTypes.ImapctEntitySearchPayload = checkResponse(response, []);
  // console.log('api.ts, searchImpactEntityViewPaperDataAPI(), data: ', data)
  return data
}

export async function searchImpactEntityViewPatentDataAPI(grant_id_list: string[], search_keyword: string, entity_level: string): Promise<ImpactViewTypes.ImapctEntitySearchPayload>  {
  const url = `${API}/search_impact_entity_view_patent_data`;
  const param = {
    grant_id_list: grant_id_list,
    search_keyword: search_keyword,
    entity_level: entity_level,
  }
  // console.log('searchImpactEntityViewPatentDataAPI(), param: ', param)

  const response = await axios.post(url, param);
  const data: ImpactViewTypes.ImapctEntitySearchPayload = checkResponse(response, []);
  // console.log('api.ts, searchImpactEntityViewPatentDataAPI(), data: ', data)
  return data
}

export async function searchImpactEntityViewClinicalTrialDataAPI(grant_id_list: string[], search_keyword: string, entity_level: string): Promise<ImpactViewTypes.ImapctEntitySearchPayload>  {
  const url = `${API}/search_impact_entity_view_clinical_trial_data`;
  const param = {
    grant_id_list: grant_id_list,
    search_keyword: search_keyword,
    entity_level: entity_level,
  }
  // console.log('searchImpactEntityViewClinicalTrialDataAPI(), param: ', param)

  const response = await axios.post(url, param);
  const data: ImpactViewTypes.ImapctEntitySearchPayload = checkResponse(response, []);
  // console.log('api.ts, searchImpactEntityViewClinicalTrialDataAPI(), data: ', data)
  return data
}

export async function searchImpactEntityViewPolicyDataAPI(grant_id_list: string[], search_keyword: string, entity_level: string): Promise<ImpactViewTypes.ImapctEntitySearchPayload>  {
  const url = `${API}/search_impact_entity_view_policy_data`;
  const param = {
    grant_id_list: grant_id_list,
    search_keyword: search_keyword,
    entity_level: entity_level,
  }
  // console.log('searchImpactEntityViewPolicyDataAPI(), param: ', param)

  const response = await axios.post(url, param);
  const data: ImpactViewTypes.ImapctEntitySearchPayload = checkResponse(response, []);
  // console.log('api.ts, searchImpactEntityViewPolicyDataAPI(), data: ', data)
  return data
}
// ===== side view (end) =====



// ===== mainview (begin) =====
export async function getMainViewlayoutOptimizationParamsAPI(params: any): Promise<any> {
  const url = `${API}/get_mainview_layout_optimization_params`;
  const response = await axios.post(url, params);
  const data: MainViewTypes.MainViewLayoutOptimizationParams = checkResponse(response, []);
  return data
}

// opt 1: using streaming output progress manager
// api.ts
export async function getMainViewDataAPI(
  fieldLevelDict: InteractionTypes.UIParamFieldLevelRangeDict,
  grantIDList: string[],

  // callback functions for streaming output progress manager
  onProgress?: (msg: string) => void,
  onDone?: () => void,
): Promise<any> {
  const url = `${API}/get_mainview_data`;
  if (grantIDList.length === 0) return;

  const reqId = uuid(); // 新增：这次请求的唯一 ID

  // ✅ 如果你已有专用 PROGRESS 根域，请用它更稳（拿到独立连接池）
  // const progressURL = `${PROGRESS_ROOT_URL}/progress/${reqId}`; // ✅ 用专用的 BASE_URL
  const progressURL = `${API}/progress/${reqId}`;

  // opt 1
  // 1) 打开 SSE（单例）：先关旧，再建新
  let closeStream = openProgressStream(progressURL, {
    onOpen: () => {
      // 握手一成功就更新文案，不必等第一条 progress
      onProgress?.('Connected. Starting...');
    },
    onMessage: (payload) => {
      if (payload?.type === 'progress' && typeof payload?.message === 'string') {
        onProgress?.(payload.message);
      } else if (payload?.type === 'done') {
        onDone?.();
        // 收到 done 就关闭
        if (closeStream) { closeStream(); closeStream = null as any; }
      }
    },
    onError: () => {
      // SSE 出错也关闭，避免占坑
      if (closeStream) { closeStream(); closeStream = null as any; }
    },
  });
  // 2) 发送计算请求（带上 req_id）
  try {
    const param = {
      req_id: reqId,
      field_level_dict: fieldLevelDict,
      grant_id_list: grantIDList,
    };
    const response = await axios.post(url, param);
    const data = checkResponse(response, []);
    return data;
  } catch (err) {
    // POST 失败关闭 SSE
    if (closeStream) { closeStream(); closeStream = null as any; }
    throw err;
  } finally {
    // 双保险：到这里如果还没关，关掉
    if (closeStream) { closeStream(); closeStream = null as any; }
  }


  // // opt 2
  // // 1) 打开 SSE，实时更新 loading label
  // const es = new EventSource(progressURL);
  // // 打开 SSE 之后，先加一个安全关闭函数
  // let closed = false;
  // const safeClose = () => {
  //   if (!closed) {
  //     es.close();
  //     closed = true;
  //   }
  // };
  // es.onmessage = (ev) => {
  //   console.log('ev: ', ev)
  //   console.log('ev.data: ', ev.data)
  //   try {
  //     // 后端若发的是 JSON 字符串
  //     const payload = JSON.parse(ev.data);

  //     if (payload?.type === 'progress' && typeof payload?.message === 'string') {
  //       onProgress?.(payload.message);
  //     } else if (payload?.type === 'done') {
  //       onDone?.();
  //       safeClose();
  //     } else {
  //       console.log('Unknown payload type:', payload);
  //     }
  //   } catch (error) {
  //     console.log('JSON parse failed, trying alternative format');
  //     // 如果后端是 Python dict（单引号），可选兜底：
  //     try {
  //       const safe = ev.data.replace(/'/g, '"');
  //       const payload = JSON.parse(safe);

  //       if (payload?.type === 'progress' && typeof payload?.message === 'string') {
  //         console.log('Progress update (safe):', payload.message);
  //         onProgress?.(payload.message);
  //       } else if (payload?.type === 'done') {
  //         console.log('Calculation completed (safe), calling onDone');
  //         onDone?.();
  //         safeClose();
  //       }
  //     } catch (safeError) {
  //       console.error('Failed to parse SSE message:', ev.data);
  //     }
  //   }
  // };
  // // 等待 EventSource 连接建立后再发送计算请求
  // console.log('Waiting for EventSource connection to establish...');
  // let connectionPromiseResolve: () => void;
  // let connectionPromiseReject: (error: Error) => void;

  // const connectionPromise = new Promise<void>((resolve, reject) => {
  //   connectionPromiseResolve = resolve;
  //   connectionPromiseReject = reject;
  // });

  // es.onopen = () => {
  //   console.log('EventSource connection established, proceeding with POST request');
  //   connectionPromiseResolve();
  // };

  // es.onerror = () => {
  //   console.warn('SSE error');
  //   safeClose();
  //   connectionPromiseReject(new Error('EventSource connection failed'));
  // };

  // // 等待连接建立
  // await connectionPromise;

  // try {
  //   const param = {
  //     req_id: reqId,
  //     field_level_dict: fieldLevelDict,
  //     grant_id_list: grantIDList,
  //   };
  //   const response = await axios.post(url, param);
  //   const data = checkResponse(response, []);
  //   return data;
  // } catch (err) {
  //   safeClose();                   // ✅ POST 失败也要关
  //   throw err;
  // } finally {
  //   // safeClose();                   // ✅ 无论成功失败都要关闭 EventSource
  // }
}

// // [abandoned] opt 2: no streaming output progress manager
// export async function getMainViewDataAPI(fieldLevelDict: InteractionTypes.UIParamFieldLevelRangeDict, grantIDList: string[]): Promise<any> {
//   const url = `${API}/get_mainview_data`;
//   // console.log('================= getMainViewDataAPI() =================')
//   // console.log('fieldLevelDict: ', fieldLevelDict)
//   // console.log('grantIDList: ', grantIDList.length, grantIDList[0])

//   if (grantIDList.length > 0) {
//     const param = {
//       field_level_dict: fieldLevelDict,
//       grant_id_list: grantIDList,
//     }
//     const response = await axios.post(url, param);
//     const data = checkResponse(response, []);
//     // console.log('getMainViewDataAPI(), return: ', data)

//     return data
//   }
// }

export async function getMainViewImpactSummaryTableDataAPI(params: string[]): Promise<MainViewTypes.ImpactSummaryViewData> {
  const url = `${API}/get_mainview_summary_table_data`;
  // console.log('getMainViewImpactSummaryTableDataAPI(), params: ', params)
  const param = {
    grant_id_list: params,
  }

  const response = await axios.post(url, param);
  const data: MainViewTypes.ImpactSummaryViewData = checkResponse(response, []);
  return data
}
// ===== mainview (end) =====





// ===== user management (begin) =====
// user management
export async function getLoginResultAPI(
  params: UserManagementTypes.UserLoginParams
): Promise<UserManagementTypes.LoginResponse> {
  const url = `${API}/login`;
  const param = {
    username: params.username,
    password: params.password,
  };
  const response = await axios.post(url, param);
  return {
    access_token: response.data.access_token,
    msg: response.data.msg,
    is_authenticated: response.data.is_authenticated,
  };
}

export async function getRegisterResultAPI(
  params: UserManagementTypes.UserRegisterParams
): Promise<UserManagementTypes.AccountChangeResponse> {
  const url = `${API}/register`;
  const param = {
    username: params.username,
    password: params.password,
    email: params.email,
  };
  const response = await axios.post(url, param);
  return {
    msg: response.data.msg,
    status: response.data.register_status,
  };
}

export async function getDeleteAccountResultAPI(
  params: UserManagementTypes.UserLoginParams
): Promise<UserManagementTypes.AccountChangeResponse> {
  const url = `${API}/delete_account`;
  const param = {
    username: params.username,
    password: params.password,
  };
  const response = await axios.post(url, param);
  return {
    msg: response.data.msg,
    status: response.data.delete_status,
  };
}

export async function getForgetPasswordResultAPI(
  params: UserManagementTypes.ForgetPasswordParams
): Promise<UserManagementTypes.AccountChangeResponse> {
  const url = `${API}/forget_password`;
  const param = {
    email: params.email,
  };
  const response = await axios.post(url, param);
  return {
    msg: response.data.msg,
    status: response.data.forget_status,
  };
}

export async function getResetPasswordResultAPI(
  params: UserManagementTypes.ResetPasswordParams
): Promise<UserManagementTypes.AccountChangeResponse> {
  const url = `${API}/reset_password`;
  const param = {
    token: params.token,
    password: params.password,
  };
  const response = await axios.post(url, param);
  return {
    msg: response.data.msg,
    status: response.data.reset_status,
  };
}

export async function getVerifyEmailResultAPI(
  params: UserManagementTypes.VerifyEmailParams
): Promise<UserManagementTypes.AccountChangeResponse> {
  const url = `${API}/verify_email`;
  const param = {
    token: params.token,
  };
  const response = await axios.post(url, param);
  return {
    msg: response.data.msg,
    status: response.data.verify_status
  }
}
// ===== user management (end) =====